module.exports = __webpack_public_path__ + "static/text_service.e445b666.png";